import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet"

import { Paper } from "@mui/material";

const GuidesLayout = () => {
  return (
    <div className="max-w-6xl mx-[10px] md:mx-auto md:flex mt-[20px]">
      <Helmet>
        <html lang="en" />
        <title>AwardTool | Guides </title>
        <meta name="description" content="Guides on saving thousands and hours with AwardTool." />
      </Helmet>
      <Paper className="bg-[#fff] min-h-[60vh] flex-1">
        <Outlet />
      </Paper>
    </div>
  );
};

export default GuidesLayout;
